import React from 'react';
import SvgIcon from '../../icons/SvgIcon';
import useKeyModRerender from '../hooks/useKeyModRerender';

const Checkbox = ({
  children,
  customModifier = null,
  customCheckName = null,
  id,
  value,
  checked,
  disabled,
  analyticsKey,
  analyticsKey2,
  className,
  displayCheckbox = true,
  onChange,
  tabIndex = '0',
  ariaLabel,
}) => {
  const keyMod = useKeyModRerender(checked);
  const combinedClassName = [
    customModifier ? `custom-control--${customModifier}` : 'control',
    disabled ? 'control--disabled' : '',
    className,
  ]
    .filter((x) => x)
    .join(' ');

  return (
    <label className={combinedClassName}>
      {displayCheckbox && (
        <>
          <input
            type="checkbox"
            className="stat-checkbox"
            key={keyMod}
            id={id}
            value={value}
            checked={checked}
            disabled={disabled}
            data-dtm={analyticsKey}
            data-dtm2={analyticsKey2}
            onChange={onChange}
            tabIndex={tabIndex}
            aria-label={ariaLabel}
          />
          <div className="control__indicator">
            {checked && customCheckName && (
              <SvgIcon name={customCheckName} className="control__check" />
            )}
            {checked && !customCheckName && !customModifier && (
              <SvgIcon name="check" className="control__check" />
            )}
          </div>
        </>
      )}

      {children}
    </label>
  );
};

export default Checkbox;
